var e = e || {},
    hydratech = hydratech || {};
( function () {
    'use strict';
    jQuery( window ).on( 'load resize', function () {
        hydratech.init();
    } );
    // Custom javascript goes here
    hydratech.init = function () {
        if ( e.constant.jWindow.width() > 768 ) {
            hydratech.viewportHeight();
        }
        else {$('.js-frontpagesection').css('height', '');}
        jQuery('.link-disabled > a').on('click', function(event){
            event.preventDefault();
        });
    };
    hydratech.viewportHeight = function () {
        var jHeight = e.constant.jWindow.height();
        var jHeader = jQuery( '.e-header' ).height();
        jQuery( '.js-frontpagesection' ).height( jHeight - jHeader );
    };
}() );
